export default __webpack_public_path__ + "static/media/info-icon.3477aa86.svg";